import { ExclamationCircle } from '@ui/components/icons';
import { Icon } from '@ui/lib/park/ui/icon';
import { Text } from '@ui/lib/park/ui/text';

type ErrorMsgProps = {
  errorMsg: React.ReactNode;
};

export const ErrorMsg: React.FC<ErrorMsgProps> = ({ errorMsg }) => {
  return (
    <>
      {errorMsg}
    </>
  );
};
